import React, { useState } from 'react';
import './Login.css';
import authService from './services/authService';
import CryptoJS from 'crypto-js';

// Owl icon component
const OwlIcon = ({ spinning = false, onClick, clicked = false }) => (
  <div 
    className={`owl-icon ${spinning ? 'spinning' : ''} ${clicked ? 'clicked' : ''}`}
    onClick={onClick}
    title="Click me! 🦉"
  >
    <span className="owl-emoji">🦉</span>
  </div>
);

function Login({ onLogin }) {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [owlClicks, setOwlClicks] = useState(0);
  const [owlClicked, setOwlClicked] = useState(false);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleOwlClick = () => {
    if (!loading) {
      setOwlClicks(prev => prev + 1);
      setOwlClicked(true);
      
      // Reset the clicked state after animation
      setTimeout(() => {
        setOwlClicked(false);
      }, 500);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Hash the password using SHA256 before sending to backend
      const hashedPassword = CryptoJS.SHA256(credentials.password).toString();
      
      // Get organization ID based on environment
      const orgId = authService.getOrganizationId();
      
      const result = await authService.login(
        credentials.username,
        hashedPassword,
        orgId
      );

      if (result.success) {
        onLogin(true);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <OwlIcon spinning={loading} onClick={handleOwlClick} clicked={owlClicked} />
          <h2>Login</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login; 